import { Color, Icon, Stack } from "@fidelix/fx-miranda";
import styled from "styled-components";

const AlarmStatusBadge = ({ variant }: { variant: Color }) => {
  return (
    <Stack align={"center"}>
      <Wrapper>
        <Icon icon="bell" />
        <StatusDot variant={variant} />
      </Wrapper>
    </Stack>
  );
};

export default AlarmStatusBadge;

const Wrapper = styled.div`
  position: relative;
`;

const StatusDot = styled.div<{ variant: Color }>`
  position: absolute;
  top: 1px;
  right: 0px;
  border: 2px solid white;
  box-sizing: content-box;

  width: 8px;
  height: 8px;
  border-radius: 50%;
  background-color: ${(p) => p.theme.colors[p.variant]};
`;
